import { JobCard } from "~~/interface/Job";
import _ from "lodash";
import { JobAction, JobCard, JobItemStatus } from "~~/interface/Job";
import { JobItem } from "~~/interface/Job";
import dayjs from "dayjs";

export default class JobschainV2 {
  jobs: Array<JobCard> = [];
  itemsUuid: { [uuid: string]: JobItem | null } = {};
  voidUuid = {};
  moveUuid = {};
  _tables = {};
  uuidDeadList = [];
  firstDeadListLoaded = false;

  uuidMapQty: any = {};

  // SPLIT_ITEM ที่หาบรรทัดต้นทางไม่เจอตอนไล่ตามเวลา จะถูกพักไว้ที่นี่แล้วทำใหม่ตอนท้าย
  deferredSplits: Array<JobCard> = [];

  constructor(jobs) {
    this.jobs = jobs;
    this.compute();
    
  }

  compute(forceJobs = null) {
    this.deferredSplits = [];
    let sorted = _.sortBy(forceJobs || this.jobs, (j) => j.timestamp);
    // sorted = _.shuffle(sorted);
    _.forEach(sorted, (job: JobCard, index) => {
      try {
        switch (job.action) {
          case JobAction.SET_START_TIME:
            this.setStartTime(job);
            break;
          case JobAction.SET_GUESTS:
            this.setGuests(job);
            break;

          //items
          case JobAction.ADD:
            this.add(job);
            break;
          case JobAction.MOVE:
            this.move(job);
            break;
          case JobAction.SPLIT_ITEM:
            this.splitItem(job);
            break;
          case JobAction.SPLIT_BILL:
            this.splitBill(job);
            break;
          case JobAction.SET_PRICE:
            this.setPrice(job);
            break;
          case JobAction.SET_DISCOUNT:
            this.setDiscount(job);
            break;
          case JobAction.SET_DISCOUNT_ENT:
            this.setDiscount(job);
            break;
          case JobAction.SET_COMMENT:
            this.setComment(job);
            break;
          case JobAction.VOID:
            this.void(job);
            break;
          case JobAction.VOID_RECEIPT:
            this.voidReceipt(job);
            break;
          case JobAction.PAY:
            this.pay(job);
            break;
        }
      } catch (error) {
        console.error(error);
        console.error(job);
        console.error("index", index);

        // ไม่โยนต่อ: ถ้าโยน compuet() จะล้มทั้งก้อน this.tables ไม่ถูกอัปเดต
        // แล้วหน้าขายทั้งหน้าค้างอยู่กับข้อมูลเก่า ซึ่งแย่กว่าการข้าม job เสียไปใบเดียว
        // job ที่มีปัญหายังถูก log ไว้ครบสำหรับตามแก้
      }
    });

    this.runDeferredSplits();
  }

  // ตอนนี้ ADD ทั้งหมดถูกประมวลผลไปแล้ว บรรทัดต้นทางจึงควรมีครบ
  // วนซ้ำเผื่อกรณีแยกซ้อนแยก (SPLIT ที่อ้างผลลัพธ์ของ SPLIT อีกใบ)
  // หยุดเมื่อไม่มีอะไรคืบหน้าแล้ว จะได้ไม่วนไม่รู้จบถ้าบรรทัดต้นทางหายจริง ๆ
  runDeferredSplits() {
    while (this.deferredSplits.length > 0) {
      const pending = this.deferredSplits;
      this.deferredSplits = [];

      pending.forEach((job) => this.splitItem(job));

      if (this.deferredSplits.length >= pending.length) {
        console.warn(
          "SPLIT_ITEM: ไม่พบบรรทัดต้นทางแม้ประมวลผลครบแล้ว",
          this.deferredSplits
        );
        break;
      }
    }
  }

 

  getItems() {
    return this.itemsUuid;
  }

  getTables() {
    //group items by table
    let tables = {};
    let tableJobId = {};
    let items = this.itemsUuid;
    _.forEach(items, (item) => {
      if (item.status == JobItemStatus.ACTIVE) {
        let table = item.table || "_unknown_";
        if (!tables[table]) {
          tables[table] = {
            items: [],
            jobs: [], // jobid
            ...this._tables[table],
          };
        }
        tables[table].items.push(item);

        let k = `${table}-${item.jobId}`;
        if (tableJobId[k] == undefined) {
          tableJobId[k] = true;
          tables[table].jobs.push(item.jobId);
        }
      }
    });

    _.forEach(tables, (table) => {
      if (!table?.items) {
        return;
      }

      table.items = _.sortBy(table.items, [
        "timestamp",
        (item) => item.row ?? Number.MAX_SAFE_INTEGER,
        "jobId",
      ]);
    });

    this.computeStartDate(tables);
    return tables;
  }

  computeStartDate(tables) {
    _.forEach(tables, (table) => {
      if (!table) {
        return;
      }
      let lowestTime = _.min(table.jobs)
      table.startDate = lowestTime || dayjs().toISOString();
    });
  }

  updateItemLine(newItemUpdate: JobItem, status: JobItemStatus, options = {}) {
    let item_prevoius = this.itemsUuid[newItemUpdate.uuid];
    if (
      item_prevoius?.status == JobItemStatus.PAID ||
      item_prevoius?.status == JobItemStatus.VOIDED
    ) {
      return;
    }
    this.itemsUuid[newItemUpdate.uuid] = {
      ...item_prevoius,
      ...newItemUpdate,
      ...options,
      status: status,
    };
  }

  add(job: JobCard) {
    _.forEach(job.items, (itemLineFromJob: ItemDatabase, i) => {

      // สำหรับ ADD ต้องทำการเทค่า ทีหลัง
      let newItem = {
        ...itemLineFromJob,
        table: job.table,
        jobId: job.jobId,
        bill: 1,
        row: i * 10,
        timestamp: job.timestamp,
        employeeId: job.employee.employeeId,
        employeeName: job.employee.name,
        discountItem: [0, 0, 0],
      };

      let item_prevoius = this.itemsUuid[itemLineFromJob.uuid];
      this.itemsUuid[itemLineFromJob.uuid] = {
        ...newItem,
        ...item_prevoius,
        status: item_prevoius?.status || JobItemStatus.ACTIVE,
      };
    });

    if (this._tables[job.table] == undefined) {
      this._tables[job.table] = {
        startDate: job.timestamp,
        guests: job.guests,
        zone: job.zone || null,
      };
    }

    

    // if (job.guests >= 1 ) {
    //     this._tables[job.table] = {
    //         startDate: job.timestamp,
    //         guests: job.guests
    //     }
    // }

    // this._tables[job.table] = {...this._tables[job.table]}
  }

  move(job: JobCard) {
    let oldTable = job.table[0];
    let newTable = job.table[1];

    // check ว่ามีคนใช้งานอยู่มั้ย หรือ เปิดโต๊ะใหม่
    //check the table is already taken or not, by find one item in new table if found, then the table is taken
    let isTableTaken = _.find(this.itemsUuid, (item) => {
      return item.table == newTable && item.status == JobItemStatus.ACTIVE;
    });

    // if new table is empty, set start time and guests from old table
    if (!isTableTaken) {


      // make safty for oldtable
     
     
      this._tables[newTable] = {
        startDate: this._tables[oldTable]?.startDate || job.timestamp,
        guests: this._tables[oldTable]?.guests || 2,
      };
    }

    _.forEach(job.items, (itemLineFromJob) => {
      this.updateItemLine(itemLineFromJob, JobItemStatus.ACTIVE, {
        table: newTable,
        jobId: job.jobId,
        timestamp: job.timestamp,
      });
    });

    this.cleanTablesWhenNoItems(oldTable);
  }

  splitItem(job: JobCard) {
    _.forEach(job.items, (itemLineFromJob) => {
      let thisItem = this.itemsUuid[itemLineFromJob.uuid];

      // ADD ของบรรทัดต้นทางยังมาไม่ถึง (นาฬิกาเครื่องเหลื่อมกัน เช่น QR order
      // จากมือถือลูกค้าที่เวลาไม่ตรง) — พักไว้ก่อน ห้ามข้ามทิ้ง
      // ถ้าข้ามทิ้ง ยอดจะเหลือเท่าเดิมเหมือนไม่เคยแยก = การตัดยอดหายไป
      // ค่อยเอามาทำใหม่ตอนท้ายเมื่อ ADD ทั้งหมดถูกประมวลผลแล้ว
      if (!thisItem) {
        this.deferredSplits.push({ ...job, items: [itemLineFromJob] });
        return;
      }

      // เพดานจำนวนต้องเช็คตอน replay ไม่ใช่แค่ตอนกดสั่ง
      // เครื่องที่กดเห็นแค่ภาพที่ sync มาถึงตอนนั้น ถ้าอีกเครื่องแยกบรรทัดเดียวกัน
      // ไปก่อน จำนวนที่ขอจะเกินของที่เหลือจริง แล้วยอดจะเฟ้อ
      // (บรรทัดแม่ติดลบเลยโดนตัดทิ้ง แต่บรรทัดลูกได้เต็มจำนวนที่ขอ)
      const take = Math.min(Math.abs(itemLineFromJob.qty), thisItem.qty);
      if (take <= 0) {
        // ไม่เหลือให้แยกแล้ว สร้างบรรทัดเปล่าไปก็มีแต่รกจอ
        return;
      }

      // new clone item
      let newItem = _.cloneDeep(thisItem);
      newItem.uuid = itemLineFromJob.newUuid;
      newItem.newLine = true;
      newItem.splited = true;
      // ต้องเซ็ตเสมอ ไม่ใช่เฉพาะตอนที่ job ส่งมา
      // ไม่งั้น cloneDeep จะลาก splitGroup ของบรรทัดแม่ติดมาด้วย
      // ทำให้ชิ้นที่แยกใหม่ไปรวมแถวกับกลุ่มเดิมโดยไม่ตั้งใจ
      newItem.splitGroup = itemLineFromJob.splitGroup || newItem.uuid;

      newItem.qty = take;
      newItem.row = thisItem.row + 1;

      // ของที่ job ใบอื่นบันทึกไว้กับ uuid นี้แล้วต้องชนะ clone ของบรรทัดแม่
      // เช่น MOVE ของบรรทัดที่แยกออก มาถึงก่อน SPLIT ที่สร้างมันขึ้นมา
      // (นาฬิกาสองเครื่องเหลื่อมกัน) ถ้าให้ clone ชนะ โต๊ะปลายทางจะถูกทับด้วย
      // โต๊ะของแม่ = การย้ายหายไปเงียบ ๆ
      // qty ต้องมาจาก job นี้เสมอ เพราะเป็นตัวเดียวที่รู้ว่าแยกกี่ชิ้น
      // หลักการเดียวกับ add() ที่ใช้ {...newItem, ...item_prevoius}
      let newItem_prevoius = this.itemsUuid[newItem.uuid];
      this.itemsUuid[newItem.uuid] = {
        ...newItem,
        ...newItem_prevoius,
        qty: take,
        status: newItem_prevoius?.status || JobItemStatus.ACTIVE,
      };

      // update original item
      thisItem.qty = thisItem.qty - take;
      this.updateItemLine(thisItem, JobItemStatus.ACTIVE);

      // if qty <= 0 then void the item
      if (thisItem.qty <= 0) {
        this.updateItemLine(itemLineFromJob, JobItemStatus.VOIDED);
      }
    });
  }
  splitBill(job: JobCard) {
    _.forEach(job.items, (itemLineFromJob) => {
      this.updateItemLine(itemLineFromJob, JobItemStatus.ACTIVE);
    });
  }

  // void items
  void(job: JobCard) {
    _.forEach(job.items, (itemLineFromJob: ItemDatabase) => {
      this.updateItemLine(itemLineFromJob, JobItemStatus.VOIDED, {
        reason: job.note || "-",
      });
    });
    this.cleanTablesWhenNoItems(job.table);
  }

  voidReceipt(job: JobCard) {
    // find one that match hash
    let payment_job = _.find(this.jobs, (j) => {
      return j.hash == job.hash;
    });

    //if found, void all items
    if (payment_job) {
      _.forEach(payment_job.items, (itemLineFromJob: ItemDatabase) => {
        this.updateItemLine(itemLineFromJob, JobItemStatus.VOIDED);
      });
    }
  }

  setPrice(job) {
    _.forEach(job.items, (itemLineFromJob) => {
      this.updateItemLine(itemLineFromJob, JobItemStatus.ACTIVE);
      let thisItem = this.itemsUuid[itemLineFromJob.uuid];
      if (thisItem?.options2) {
        thisItem.options2.forEach((option) => {
          option.price = 0;
        });
      }
    });
  }

  setComment(job: JobCard) {
    _.forEach(job.items, (itemLineFromJob) => {
      this.updateItemLine(itemLineFromJob, JobItemStatus.ACTIVE);
    });
  }

  setDiscount(job) {
    _.forEach(job.items, (itemLineFromJob) => {
      this.updateItemLine(itemLineFromJob, JobItemStatus.ACTIVE);
    });
  }

  pay(job: JobCard) {
    _.forEach(job.items, (itemLineFromJob: ItemDatabase) => {
      this.updateItemLine(itemLineFromJob, JobItemStatus.PAID);
    });
    this.cleanTablesWhenNoItems(job.table);
  }

  //status table methods
  setGuests(job: JobCard) {
    let table = job.table;

    // if table is not in the list, add it
    if (!this._tables[table]) {
      return;
    }

    // add guests to the table
    this._tables[table].guests = job.guests || 1;
  }

  setStartTime(job: JobCard) {
    let table = job.table;
    this._tables[table].startDate = job.value;
  }

  cleanTablesWhenNoItems(tableKey: string) {

    // let activeItems =   _.filter(this.itemsUuid, (item) => {
    //   return item.table == tableKey && item.status == JobItemStatus.ACTIVE;
    // });

    let activeItems = null;
    for (const uuid in this.itemsUuid) {
      const item = this.itemsUuid[uuid];
      if (item?.table == tableKey && item?.status == JobItemStatus.ACTIVE) {
        activeItems = item;
        break; // Exit loop on first match
      }
    }

    if (activeItems == null) {
      delete this._tables[tableKey];
    }
  }
}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { JobschainV2 };
